module.exports = __webpack_public_path__ + "static/media/chevron-circle-left.bb806fa9.svg";